// import { useContext } from 'react'
import PhoneIcon from '@mui/icons-material/Phone'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Grid,
  Typography,
} from '@mui/material'
import I18n from 'i18n-js'
import Map from '../map'
// import { AuthContext } from '../../context/auth'
// import { canAccess } from '../../router/permissions'
// import { actionKeys, pagesKeys } from '../../utils'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import useStyles from './style'

const CardMap = ({ center, data, checked, onCheckedChange, addCheck = false }) => {
  //state
  // const { state } = useContext(AuthContext)
  const history = useHistory()
  // const viewDetail = canAccess(
  //   actionKeys.detail,
  //   pagesKeys.medicalcenter,
  //   state
  // )
  const centerXY = {
    lat: parseFloat(
      center?.latitud && center?.latitud !== null
        ? center.latitud
        : '0.00000000000000000000'
    ),
    lng: parseFloat(
      center?.longitud && center?.longitud !== null
        ? center.longitud
        : '0.00000000000000000000'
    ),
  }

  const classes = useStyles()
  return (
    <Card
      className={classes.card}
      sx={{
        border: checked ? '2px solid #1976d2' : undefined,
      }}
    >
      <CardContent className={classes.cardContent}>
        <Grid container spacing={2}>
          <Grid item xs={7}>
            <Box display="flex" alignItems="flex-start" gap={1}>
              {
                addCheck && (
                  <Checkbox
                    checked={!!checked}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => onCheckedChange?.(e.target.checked, center)}
                    inputProps={{ 'aria-label': 'Seleccionar centro médico' }}
                    sx={{ padding: 0, marginTop: '2px' }}
                  />
                )
              }

              <Typography
                onClick={() => {
                  history.push(`/dashboard/medical-center/${center.id}`)
                }}
                className={classes.title}
              >
                <span className="title">{center?.name}</span>
                <br />
                <span className="subtitle">{center?.address}</span>
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={5}>
            <Box className={classes.icons}>
              <div className={classes.itemContainer}>
                <SupervisorAccountIcon />

                <Typography variant="body1" className={classes.textSeparation}>
                  {center.patients_count + ' ' + I18n.t('components.homeCard')}
                </Typography>
              </div>

              <div className={classes.itemContainer}>
                <PhoneIcon />

                <Typography variant="body1" className={classes.textSeparation}>
                  {center.phone}
                </Typography>
              </div>
            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <CardMedia>
        <Map center={centerXY} data={data} />
      </CardMedia>
    </Card>
  )
}

export default CardMap
